import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { uniqueId } from "lodash";

export default function DownloadIcon(props) {
  const filterId = "paint0_linear_download" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5438 9.98274C11.0038 9.54017 11.7355 9.5543 12.1781 10.0143L13.9808 11.888V3.1558C13.9808 2.51747 14.4982 2 15.1366 2C15.7749 2 16.2924 2.51747 16.2924 3.1558V11.768L17.9705 9.83104C18.3884 9.34858 19.1184 9.29632 19.6008 9.7143C20.0833 10.1323 20.1356 10.8622 19.7176 11.3447L16.0606 15.5657C15.848 15.8112 15.5419 15.9558 15.2172 15.9643C14.8926 15.9728 14.5793 15.8442 14.3542 15.6102L10.5123 11.617C10.0697 11.157 10.0838 10.4253 10.5438 9.98274ZM8.3116 14C8.3116 13.3617 7.79413 12.8442 7.1558 12.8442C6.51747 12.8442 6 13.3617 6 14V24C6 24.6384 6.51747 25.1558 7.1558 25.1558L7.16553 25.1558H23.1422L23.156 25.1559C23.7943 25.1559 24.3118 24.6384 24.3118 24.0001V14.0001C24.3118 13.3617 23.7943 12.8443 23.156 12.8443C22.5176 12.8443 22.0002 13.3617 22.0002 14.0001V22.8442H8.3116V14Z"
          fill={filterUrl}
        />
        <Defs>
          <LinearGradient
            id={filterId}
            x1="6"
            y1="7.02176"
            x2="18.633"
            y2="27.4348"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
